import { render, staticRenderFns } from "./DefaultErrorText.vue?vue&type=template&id=62f467be&scoped=true&"
import script from "./DefaultErrorText.vue?vue&type=script&lang=js&"
export * from "./DefaultErrorText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f467be",
  null
  
)

export default component.exports